<template>
  <header class="main-header" style="text-align: center; color:white">
    <div
      class="d-flex align-items-center logo-box justify-content-start"
      style="background-color: #18222A;"
    >
      <a
        href="#"
        class="waves-effect waves-light nav-link d-none d-md-inline-block mx-10 push-btn bg-transparent"
        data-toggle="push-menu"
        role="button"
      >
        <span class="icon-Align-left">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
        </span>
      </a>
      <!-- Logo -->
      <a href="#" class="logo">
        <!-- logo-->
        <div class="logo-lg">
          <div class="logo-lg">
            <span class="light-logo" style="color: white;">
              <i class="fa-solid fa-graduation-cap"></i> SHOOLMAKER
            </span>
          </div>

          <!-- <span class="light-logo"><img src="assets/images/logo-dark.PNG" alt="logo"></span>
          <span class="dark-logo"><img src="assets/images/logo-dark.PNG" alt="logo"></span>-->
        </div>
      </a>
    </div>
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->

      <button class="btn btn-primary btn-sm" @click="goBack">
        <i class="fas fa-arrow-left"></i> Arrière
      </button>
      <div class="navbar-custom-menu r-side">
        <ul class="nav navbar-nav">
          <!-- User Account-->
          <li class="dropdown user user-menu">
            <a
              href="#"
              class="waves-effect waves-light dropdown-toggle"
              data-toggle="dropdown"
              title="Logout"
            >
              <i class="icon-User">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </a>
            <ul class="dropdown-menu animated flipInX">
              <li class="user-body" @click="Logout">
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="login">
                  <i class="ti-lock text-muted mr-2"></i>
                  Logout
                </a>
              </li>
            </ul>
          </li>

          <!-- Control Sidebar Toggle Button -->
          <li>
            <a href="#" title="Synchroniser" @click="Actualiser">
              <Icon type="md-refresh-circle" />
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  mounted() {
    // console.log('Component mounted.')
  },

  methods: {
    goBack() {
      this.$router.go(-1); // Retour en arrière
    },
    Actualiser() {
      this.$router.go();
    },
    Logout() {
      // this.$router.push("login");
      localStorage.clear();
    }
  }
};
</script>
